<template>
  <div class="layout">
    <app-header class="header--white"></app-header>
    <main class="main main--default">
      <nuxt />
    </main>
    <span
      v-show="false"
      id="ScMail"
    >{{ accountEmail }}</span>
    <app-footer></app-footer>
    <portal-target name="overlay"></portal-target>
  </div>
</template>

<script>
import PageUtils from '~/mixins/page/page-utils'

import AppHeader from '~/components/AppHeader'
import AppFooter from '~/components/AppFooter'
import {mapGetters} from 'vuex'

export default {
  name: 'DefaultLayout',
  components: {
    AppHeader,
    AppFooter
  },
  mixins: [
    PageUtils
  ],
  computed: {
    ...mapGetters('modules/account', ['accountEmail'])
  },
  beforeMount() {
    this.$store.dispatch('modules/account/fetchAccount')
    this.$store.dispatch('modules/status-panel/fetchStatus')
  },
  head() {
    return {
      htmlAttrs: {
        lang: this.$i18n.locale
      }
    }
  }
}
</script>

<style lang="scss">
.main--default {
  padding-top: 78px;

  @media (max-width: $breakpoint-xxl + 1) {
    padding-top: 79px;
  }

  @media (max-width: $breakpoint-lg) {
    padding-top: 48px;
  }
}
</style>